module.exports = __webpack_public_path__ + "static/media/4.d86872bb.png";